/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Icon from '@mui/material/Icon';

import { useInitSquare } from 'hooks';
import { ReactComponent as SquareIcon } from 'assets/square.svg';

import { useCallbackWithLoader } from '../../hooks/useCallbackWithLoader';
import { showMessage } from '../../store/slices/message.slice';

import PaymentErrors from './PaymentErrors';
import { tokenize } from './utils';
import UserPaymentFormWrapper from './components/UserPaymentFormWrapper';

const SquareUserPaymentForm = ({ plans, isRenewForm = false, onSubmitHandler, setLoading }) => {
	const { handleSubmit, getValues } = useFormContext();
	const dispatch = useDispatch();

	const onInitCard = useCallback(() => setLoading(false), [setLoading]);

	const { createPayment, paymentMethod, cardErrors } = useInitSquare({
		onInitializeCard: onInitCard
	});

	const handleProceedPayment =
		({ payMethod }) =>
		async () => {
			const { token, errors } = await tokenize(payMethod);

			if (errors) return;

			const formData = getValues();

			try {
				return await createPayment({
					token,
					paymentHandler: onSubmitHandler,
					paymentData: {
						plan_type: formData.plan_type,
						card_on_file: formData.save_card_information,
						fname: formData.first_name,
						lname: formData.last_name,
						...(isRenewForm && { email: formData.email })
					}
				});
			} catch (e) {
				console.error('PAYMENT FAILED: ', e);
				dispatch(
					showMessage({
						message: 'Payment Failed! Please, try again later',
						variant: 'error'
					})
				);
			}
		};

	const { callback: onSubmit, loading } = useCallbackWithLoader(
		handleProceedPayment({ payMethod: paymentMethod, shouldVerify: true })
	);

	return (
		<form id="payment-form" onSubmit={handleSubmit(onSubmit)}>
			<Icon sx={{ fontSize: '4rem', position: 'absolute', right: 20, top: 0 }}>
				<SquareIcon />
			</Icon>
			<UserPaymentFormWrapper isRenewForm={isRenewForm} loading={loading} plans={plans}>
				<Grid item xs={12}>
					<Box id="card-container"></Box>
				</Grid>
				<Grid item xs={12}>
					<PaymentErrors errors={cardErrors} />
				</Grid>
			</UserPaymentFormWrapper>
		</form>
	);
};

export default SquareUserPaymentForm;
